import React, { Component } from 'react';
import { connect } from 'react-redux';

import OrderHistoryItem from './OrderHistoryItem.jsx';

class OrderHistoryOrder extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isHidden: true
    };
    this.toggleHiddenState = this.toggleHiddenState.bind(this);
  }

  toggleHiddenState() {
    this.setState({isHidden: !this.state.isHidden});
  }

  render() {
    let oOrderItems = this.props.order.items.map((oItem, index) => {
      //old orders have dup items. mmmid isn't unique enough
      return <OrderHistoryItem key={oItem.mmid + '_' + index} item={oItem} />
    });

    let nTrackingNumber = this.props.order.tracking_id;
    let sTrackingLink   = 'http://trkcnfrm1.smi.usps.com/PTSInternetWeb/InterLabelInquiry.do?origTrackNum=' + nTrackingNumber;
    let nTrackingDisplay = nTrackingNumber ? <a href={sTrackingLink} target="_blank">{nTrackingNumber}</a> : 'Currently Unavailable';

    return (
        <ul key={this.props.order.id}>
          <li className="order-header" onClick={this.toggleHiddenState}>
            <div className={"arrow" + (this.state.isHidden ? " down" : " up")}></div>
            <ul>
              <li>{this.props.order.created_at}</li>
              <li className="text-right"><span className="mobile-420-hide">Order</span># {this.props.order.reference_id}</li>
            </ul>
          </li>
          <li className={"order-details" + (this.state.isHidden ? " hidden" : "")}>
            <div className="tracking">
              <span className="list-header">Track your order: </span>
                {nTrackingDisplay}
            </div>
            <div className="half-col">
              <ul className="list">
                <li className="list-header">Shippped to:</li>
                <li>
                  {this.props.customer.first_name + ' ' + this.props.customer.last_name}
                </li>
                <li>
                  {this.props.order.shipping_street}
                </li>
                <li>
                  {this.props.order.shipping_city + ", "}
                  {(this.props.order.shipping_state_abbr || this.props.order.shipping_state) + " "}
                  {this.props.order.shipping_zip}
                 </li>
              </ul>
            </div>
            <ul>
              {oOrderItems}
            </ul>
            <div className="text-right"><span className="list-header">Order Total: ${this.props.order.grand_total.toFixed(2)}</span></div>
          </li>
        </ul>
    );
  }
};


function mapStateToProps(state){
    return {
      'customer': state.customer
    };
}

export default connect(mapStateToProps)(OrderHistoryOrder);


// WEBPACK FOOTER //
// ./src/components/OrderHistoryOrder.jsx